import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_1: R2BReferralBrandEntity = {
  token: "r2b_referral_1",
  type: "r2bReferralBrand",
  name: "Evergreen Goods",
  email: "kayden.renner@example.com",
  website: "shoptopia.com",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
